// @flow
import Handler from "./handler.js";

const TIMEOUT = 500;
const MAX_TENSION = 350;

export default class Wheel extends Handler {
	// XXX: https://github.com/facebook/flow/issues/3076
	handleWheel: (ev: WheelEvent) => void;

	tension: number = 0;
	tensionTimeout: number;

	constructor(scroller: any) {
		super(scroller);
		this.handleWheel = this.handleWheel.bind(this);

		const {binder} = this.scroller;
		binder.addBinding("wheel", this.handleWheel);
	}

	reset = () => {
		this.tension = 0;
		this.scroller.setScrollHandler();
	}

	refreshTimer() {
		clearTimeout(this.tensionTimeout);
		this.tensionTimeout = setTimeout(this.reset, TIMEOUT);
	}

	clampWithTension(lastScroll: number, nextScroll: number): boolean {
		const {scroller} = this;
		this.refreshTimer();

		const delta = nextScroll - lastScroll;
		const target = scroller.spring.running ? scroller.springTarget : lastScroll;
		const overflow = scroller.clampOverflow(target, target + delta, !scroller.spring.running);
		if (!overflow) {
			this.tension = 0;
			return scroller.spring.running;
		}

		this.tension += overflow;

		if (Math.abs(this.tension) >= MAX_TENSION) {
			const direction = this.tension < 0 ? "start" : "end";
			const position = scroller.position.target +
				(direction === "start" ? -1 : 1);
			this.tension = 0;
			clearTimeout(this.tensionTimeout);
			scroller.snapToPosition(position, direction === "end" ? "start" : "end");
		}

		return true;
	}

	handleWheel(ev: WheelEvent) {
		this.refreshTimer();
		const {scroller} = this;
		const horizontal = Math.abs(ev.deltaX) > Math.abs(ev.deltaY);
		if (horizontal !== scroller.horizontal) {
			return;
		}

		ev.stopPropagation();

		if (!scroller.setScrollHandler(this) || scroller.spring.running) {
			ev.preventDefault();
			return;
		}

		const {currentScroll} = scroller;
		const delta = horizontal ? ev.deltaX : ev.deltaY;
		const maxFreeScroll = scroller.getMaxFreeScrollInDirection(delta < 0 ? "start" : "end");

		// $FlowFixMe: flow does not know the constants
		if (!maxFreeScroll || ev.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
			// either at an edge, or using pixel scrolling
			const multiplier =
				// $FlowFixMe
				ev.deltaMode === WheelEvent.DOM_DELTA_PAGE ? MAX_TENSION :
				// $FlowFixMe
				ev.deltaMode === WheelEvent.DOM_DELTA_LINE ? 75 :
				1;
			const nextScroll = currentScroll + (delta * multiplier);
			const didSnap = this.clampWithTension(currentScroll, nextScroll);

			// XXX: in an attempt to avoid flickering caused by native scrolls, we
			// preventDefault all the pixel scrolling typically on mac. This loses
			// the ability to do kinetic scrolling however.
			ev.preventDefault();
			if (!didSnap) {
				scroller.currentScroll = nextScroll;
			}

			//// We only preventDefault when we did snap, because we want to have the
			//// native behavior otherwise, either for non-pixel based scrolling and
			//// also to have kinetic scrolling.
			//if (didSnap) {
			//  ev.preventDefault();
			//}
			return;
		}
	}

	handleScroll(nextScroll: number, lastScroll: number) {
		this.clampWithTension(lastScroll, nextScroll);
	}

	unmount() {
		this.scroller.binder.removeBinding("wheel", this.handleWheel);
	}
}



// WEBPACK FOOTER //
// ./lib/scroller/wheel.js